module.exports = __webpack_public_path__ + "img/choose-04.278c685b.png";